import React, {useEffect, useState} from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";

import downloadFiles from '../../helpers/downloadFiles';
import {AppBar, ButtonResponsive, ListViewMode, LoadingProgress} from "../../components";
import {CloudDownloadOutlined, FilterList} from "@mui/icons-material";
import Strings from '../../assets/strings'
import {getSaldoAntiguedad} from "../../services";
import {SelectRuta} from "../../components/selects";
import {formatPeso} from "../../helpers";


const initialState={
    rutaId:undefined,
}
export default function SaldoPorAntiguedad() {
    const [clientes, setClientes] = useState<{cliente:string, balance:number, antiguedad: number}[]>([]);


    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialState);
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        setLoading(true)
        getSaldoAntiguedad().then(({data}) => {
            setClientes(data)
        }).finally(()=>setLoading(false))
    }, [filter,setClientes,setLoading]);

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFilter({...filter,[name]:value});
    };

    const searchFilter = () => {
        setOpenFilter(false);
    };

    return (
      <>
          <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} fullWidth maxWidth={"xs"}>
              <DialogContent>
                  <Grid container spacing={3}>

                      <Grid item xs={12}>
                          <SelectRuta value={filter.rutaId} name={"rutaId"} onChange={handleFilter} />
                      </Grid>
                  </Grid>
                  <br/>
              </DialogContent>
              <DialogActions>
                  <Button onClick={()=>setOpenFilter(false)} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                  <Button color="primary" onClick={searchFilter} variant={"outlined"}>{Strings.filtrar}</Button>
              </DialogActions>
          </Dialog>

          <AppBar title={Strings.saldoPorAntiguedad}/>
          <section className="contentInner">
              {loading && <LoadingProgress vh/>}
              {/*{error && <MostrarError errors={error}/>}*/}
              <ListViewMode pageRows={clientes?.length} pageTotalRows={clientes?.length}>
                  <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(!openFilter)}/>
                  <ButtonResponsive icon={<CloudDownloadOutlined/>} text={Strings.exportar} disabled={!clientes.length} onClick={()=>downloadFiles(filter,"saldoXantiguedad")}/>
              </ListViewMode>
              <br/>
              <Grid container spacing={3}>
                  <Grid item xs={12}>
                      <TableContainer>
                          <Table>
                              <TableHead>
                                  <TableRow>
                                      <TableCell>{Strings.cliente}</TableCell>
                                      <TableCell>{Strings.balance}</TableCell>
                                      <TableCell align={"right"}>De 1 - 30 días</TableCell>
                                      <TableCell align={"right"}>De 31 - 60 días</TableCell>
                                      <TableCell align={"right"}>De 61 - 90 días</TableCell>
                                      <TableCell align={"right"}>Mas de 91 días</TableCell>
                                  </TableRow>
                              </TableHead>
                              <TableBody>
                                  <TableRow>
                                      <TableCell colSpan={2} sx={{height: "11px !important"}}/>
                                      <TableCell colSpan={4} sx={{
                                          height: "11px !important",
                                          padding: "0px !important",
                                          background: "#eeeeee",
                                          textAlign: "center",
                                      }}>Antigüedad</TableCell>
                                  </TableRow>
                                  {clientes?.map((cliente, index)=>
                                      <TableRow key={index}>
                                          <TableCell>{cliente.cliente}</TableCell>
                                          <TableCell>{formatPeso(cliente.balance)}</TableCell>
                                          <TableCell align={"right"}>{cliente.antiguedad === 1 && formatPeso(cliente.balance)}</TableCell>
                                          <TableCell align={"right"}>{cliente.antiguedad === 2 && formatPeso(cliente.balance)}</TableCell>
                                          <TableCell align={"right"}>{cliente.antiguedad === 3 && formatPeso(cliente.balance)}</TableCell>
                                          <TableCell align={"right"}>{cliente.antiguedad === 4 && formatPeso(cliente.balance)}</TableCell>
                                      </TableRow>
                                  )}
                              </TableBody>
                              {/*<TableFooter>*/}
                              {/*    <TableRow>*/}
                              {/*        <TableCell align={"right"}>{Strings.total}:</TableCell>*/}
                              {/*        {mesTotal()}*/}
                              {/*    </TableRow>*/}
                              {/*</TableFooter>*/}
                          </Table>
                      </TableContainer>
                  </Grid>

              </Grid>

          </section>
      </>
    );
}
